var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "#07B262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/Dot.6ae61c2ffb0ce116d0dab79cbb567e0b.svg";
export { ForwardRef as ReactComponent };